import ReactTooltip from "react-tooltip";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import { FaCog } from "react-icons/fa";
import { useEffect, useState } from "react";
import Title from "../../../components/Title";
import api from "../../../config";
import { showMessageError } from "../../../classes/functions";
import "./index.css";

export default function QRCode(){
    const [carrying, setCarrying] = useState(false);
    const [QRCodeURL, setQRCodeURL] = useState("")
;
    function getQRCode(){
        api
        .get("/api/parameters/qrcode")
        .then((response) => {
            setQRCodeURL(response?.data?.qrcode);
        })
        .catch((error) => {
            console.log(error);

            if(error?.response?.data){
                showMessageError(error?.response?.data);
            }
        })
    }

    useEffect(() => {
        getQRCode();
    }, []);

    return (
        <div style={{height: "100%"}}>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            {!carrying && <div className="content" style={{height: "100%"}}>
                <Title name="QR Code APP"></Title>
                <div id="qr_code">
                    <img src={`data:image/svg+xml;base64,${QRCodeURL}`} width="200" height="200" title="QR Code APP" style={{width: "100%", height: "100%"}} />
                </div>
            </div>}
        </div>
    )
}